export default "__VITE_ASSET__DeVhPx7c__"